import { alpha, Theme } from '@mui/material/styles';
import { createStyles } from "@mui/styles";

const boxStyle = (theme: Theme) => createStyles({
    root: {
        ...theme.genie.font,
        flexWrap: "unset",
        position: "relative",
        padding: theme.spacing(2),
        color: theme.palette.common.black,
        "& b, & strong": {
            fontWeight: "bold"
        },
    },

    padding1x: {
        padding: theme.spacing(1),
    },

    padding2x: {
        padding: theme.spacing(2),
    },

    info: {
        backgroundColor: alpha(theme.genie.palette.info.light, .5),
    },
    success: {
        backgroundColor: alpha(theme.genie.palette.success.light, .5),
    },
    warning: {
        backgroundColor: alpha(theme.genie.palette.warning.light, .5),
    },
    error: {
        backgroundColor: alpha(theme.palette.error.light, .5),
    },
    primary: {
        backgroundColor: alpha(theme.palette.primary.light, .5),
    },
    secondary: {
        backgroundColor: alpha(theme.palette.secondary.light, .5),
    },
    muted: {
        backgroundColor: theme.genie.palette.muted.main,
        color: theme.genie.palette.muted.dark
    },
    mutedLight: {
        backgroundColor: theme.genie.palette.muted.light,
        color: theme.genie.palette.muted.dark
    },
    mutedDark: {
        backgroundColor: theme.genie.palette.muted.dark,
        color: theme.genie.palette.muted.contrastText
    },
    notice: {
        backgroundColor: theme.genie.palette.notice.dark
    },
    inherit: {
        color: "inherit"
    },

    border: {
        borderWidth: 1,
        borderStyle: "solid",
        "&$info": {
            borderColor: theme.genie.palette.info.dark,
        },
        "&$success": {
            borderColor: theme.genie.palette.success.dark,
        },
        "&$warning": {
            borderColor: theme.genie.palette.warning.dark,
        },
        "&$error": {
            borderColor: theme.palette.error.dark,
        },
        "&$primary": {
            borderColor: theme.palette.primary.dark,
        },
        "&$secondary": {
            borderColor: theme.palette.secondary.dark,
        },
        "&$notice": {
            borderColor: theme.genie.palette.notice.main,
        },
        "&$muted": {
            borderColor: theme.genie.palette.muted.main,
        },
        "&$mutedLight": {
            borderColor: theme.genie.palette.muted.light,
        },
        "&$mutedDark": {
            borderColor: theme.genie.palette.muted.dark,
        },
    }

});

export default boxStyle;
